export default __webpack_public_path__ + "static/media/walking_man.cb5232e7.gif";